import { useCurrentUser } from '@/hooks/data/user';
import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
import { trackEvent } from '@/utils/tools/segment/tracking';
import { Download, Lock } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Stack } from '@mui/material';
import Link from 'next/link';
import { useState } from 'react';

export default function DownloadItemButton(props) {
   const { itemId, itemType, itemPremium, item } = props;
   const { user, error, isLoading } = useCurrentUser();
   const [downloadError, setDownloadError] = useState(null);
   const [downloadLoading, setDownloadLoading] = useState(false);

   function userCanDownload(user) {
      if (itemPremium) {
         // check if user premium
         if (!user?.isPremium) return false;
         // check user download usage
         if (user?.downloadUsage >= user?.downloadLimit) return false;
      }
      if (!itemPremium) {
         // check user download usage
         if (user?.downloadUsage >= user?.downloadLimit) return false;
      }

      return true;
   }
   const startDownload = async () => {
      setDownloadLoading(true);
      setDownloadError(null);
      let downloadUrl = '';
      try {
         const response = await fetch(`/api/items/download?assetType=${itemType}&itemId=${itemId}`).then(
            async (response) => {
               if (!response.ok) {
                  const error = new Error('An error occurred while downloading the file.');
                  // get error message from body or default to response status
                  error.info = await response.json();
                  error.status = response.status;
                  throw error;
               }
               return response.json();
            }
         );
         downloadUrl = response.downloadFile;
      } catch (error) {
         setDownloadError(error);
         setDownloadLoading(false);
      }

      if (downloadUrl) {
         // download file from url in the same page
         const link = document.createElement('a');
         link.href = downloadUrl;
         link.setAttribute('download', 'file');
         document.body.appendChild(link);
         link.click();
         link.remove();
         trackEvent(SG_EVENT_NAMES.USER_DOWNLOAD_ITEM, {
            from: 'web',
            itemId,
            itemType,
            itemPremium,
            categories: item?.categories.map((c) => c.slug),
            author: item?.author_information?.email,
         });

         setDownloadLoading(false);
      }
   };

   if (isLoading) return <p>Loading...</p>;

   if (error) return <p>Error: {error.message}</p>;

   if (user) {
      return (
         <Stack direction="column" spacing={4}>
            {userCanDownload(user) && (
               <LoadingButton
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<Download />}
                  onClick={startDownload}
                  loading={downloadLoading}
                  loadingPosition="start"
                  disabled={downloadLoading}
               >
                  {downloadLoading ? 'Downloading...' : 'Download'}
               </LoadingButton>
            )}
            {!userCanDownload(user) && (
               <Button variant="contained" color="primary" size="large" startIcon={<Lock />}>
                  <Link href="/upgrade" target="_blank">Upgrade to download</Link>
               </Button>
            )}

            {downloadError && (
               <Alert severity="error">
                  <p>{downloadError.info?.message || downloadError.message}</p>
               </Alert>
            )}
         </Stack>
      );
   }
}
